import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "quiz-card-contribution-title" }
const _hoisted_4 = { class: "quiz-card-contribution-description" }
const _hoisted_5 = { class: "quiz-card-contribution-title" }
const _hoisted_6 = { class: "quiz-card-contribution-description" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Select")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppRangeSlider = _resolveComponent("AppRangeSlider")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Adjust your contribution style",
    description: _ctx.data.description,
    class: "quiz-card--contribution",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[1] || (_cache[1] = ($event: any) => (_ctx.QuizService.close())),
    "is-vertically-aligned": true
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, { onClick: _ctx.navigateNext }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.data.picture,
          alt: "",
          class: "quiz-card-contribution-image"
        }, null, 8, _hoisted_2)
      ]),
      _createVNode(_component_AppRangeSlider, {
        min: 0,
        max: 100,
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.value = parseInt($event, 10)))
      }, {
        "description-min": _withCtx(() => [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.data.min.title), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.data.min.description), 1)
        ]),
        "description-max": _withCtx(() => [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.data.max.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.data.max.description), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["description", "onQuizNavigation:back"]))
}